import Modal, { ModalProps } from '@material-ui/core/Modal';
import React from 'react';
import {
	useDisableFocusTrapWithChatProps
} from '@components/ChatAwareComponents/utilities/hooks/useDisableFocusTrapWithChatProps/useDisableFocusTrapWithChatProps';

export const ChatAwareModal: React.FC<ModalProps> = ({ children, ...modalProps }) => {
	const disableFocusTrapWithChatProps = useDisableFocusTrapWithChatProps();

	return (
		<Modal
			{...disableFocusTrapWithChatProps}
			{...modalProps}
		>
			{children}
		</Modal>
	);
};
